import './styles.scss';

import { StrategyPanel } from '../../strategy-panel';
import { SpecificationGlobalConfig } from './specification-global-config';

interface SpecificationProps {
  // Id of the strategy whose config to show — resolved by the shell from the
  // single `selectedStrategy` (the Overview table's selection) that scopes
  // every other tab, so Specification never has its own selection state.
  strategyId: string | null;
}

// The full, editable backtest specification. The backtest-global config
// (token / period / frequency, shared by all stratlets) sits at the top; below
// it the entire StrategyPanel config form (account / execution / entry & exit
// conditions / hedging / portfolio / roll positions) for the selected stratlet.
//
// It shows the stratlet selected in the Overview table (via strategyId) and
// hides StrategyPanel's own switcher sidebar, so there's exactly one selection
// mechanism across all tabs — not a shadow copy.
//
// The form stays editable after a run: edits persist to the strategy drafts,
// and "Rerun backtest" reads those drafts (runBacktest falls back to the
// stored draft when a form isn't mounted), so tweak-and-rerun works without a
// separate read-only/locked mode. Displayed results still reflect the LAST run
// until a rerun — an intentional "edited config vs last results" separation.
export const Specification = ({ strategyId }: SpecificationProps) => (
  <div className="backtest-result-view backtest-result-specification">
    <StrategyPanel
      hideSidebar
      activeStrategyIdOverride={strategyId}
      beforeSections={<SpecificationGlobalConfig />}
    />
  </div>
);
